import { render, staticRenderFns } from "./TabbedNav.vue?vue&type=template&id=25514ccc&scoped=true&"
import script from "./TabbedNav.vue?vue&type=script&lang=ts&"
export * from "./TabbedNav.vue?vue&type=script&lang=ts&"
import style0 from "./TabbedNav.vue?vue&type=style&index=0&id=25514ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25514ccc",
  null
  
)

export default component.exports